import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import SplashPage from "./pages/SplashPage";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Application from "./pages/Application"; // Add this import
import WhatsAppWidget from "./components/WhatsAppWidget";
import "./styles/global.css";

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<SplashPage />} />
          <Route path="/login" element={<Login />} />
          <Route 
            path="/dashboard" 
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } 
          />
          {/* Add the Application route - publicly accessible */}
          <Route path="/mighty-men-apply" element={<Application />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
        <WhatsAppWidget />
      </Router>
    </AuthProvider>
  );
}

export default App;